import React, { useState, useEffect } from "react";
import { useAuth } from "@/App";
import { AppSidebar, SidebarMenuButton } from "./AppSidebar";
import { Loader2 } from "lucide-react";
import { ThyroidIcon } from "@/components/thyroid/ThyroidIcon";
import ThyroidNurseView from "../components/thyroid/ThyroidNurseView";
import ThyroidDoctorView from "../components/thyroid/ThyroidDoctorView";

const API = process.env.REACT_APP_BACKEND_URL;

export default function ThyroidClinicPage() {
  const { token } = useAuth();
  const [access, setAccess] = useState(null);
  const [loading, setLoading] = useState(true);
  const [sidebarOpen, setSidebarOpen] = useState(false);

  useEffect(() => {
    const check = async () => {
      try {
        const t = token || localStorage.getItem("session_token");
        const res = await fetch(`${API}/api/thyroid/access`, {
          headers: { Authorization: `Bearer ${t}` },
        });
        const data = await res.json();
        setAccess(data);
      } catch (_e) {
        setAccess({ has_access: false });
      }
      setLoading(false);
    };
    check();
  }, [token]);

  const sessionToken = token || localStorage.getItem("session_token") || "";

  return (
    <div className="min-h-screen bg-[#f8fafc]" data-testid="thyroid-clinic-page" translate="no">
      <AppSidebar open={sidebarOpen} onClose={() => setSidebarOpen(false)} />
      <div className="md:ml-64">
        {/* Header */}
        <div className="bg-white border-b border-slate-200 px-6 py-4">
          <div className="flex items-center gap-3">
            <SidebarMenuButton onClick={() => setSidebarOpen(true)} />
            <ThyroidIcon className="w-7 h-7 text-[#00658D]" />
            <div>
              <h1 className="text-xl font-bold text-slate-900">Kilpnäärme Kliinik</h1>
              <p className="text-sm text-slate-500">AI kilpnäärme diagnostika</p>
            </div>
          </div>
        </div>

        <div className="p-4 md:p-8">
          {loading ? (
            <div className="flex justify-center items-center py-20">
              <Loader2 className="w-8 h-8 animate-spin text-[#00658D]" />
            </div>
          ) : !access?.has_access ? (
            <div className="max-w-xl mx-auto mt-20 text-center" data-testid="thyroid-no-access">
              <div className="rounded-2xl p-8 bg-white shadow-sm border border-gray-100">
                <h2 className="text-xl font-bold text-gray-900 mb-2">Ligipääs piiratud</h2>
                <p className="text-gray-500">Teil puudub ligipääs Kilpnäärme Kliiniku moodulile. Pöörduge administraatori poole.</p>
              </div>
            </div>
          ) : access.role === "doctor" ? (
            <ThyroidDoctorView token={sessionToken} userName={access.name} />
          ) : (
            <ThyroidNurseView token={sessionToken} userName={access.name} />
          )}
        </div>
      </div>
    </div>
  );
}
